import { createListenerMiddleware } from '@reduxjs/toolkit';

import { RootDispatch, RootState } from '../store';

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening.withTypes<RootState, RootDispatch>();
